import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import DialedDigitExtractionServerList from './containers/TLSProfileList';
import DialedDigitExtractionServerCreate from './containers/TLSProfileCreate';
import DialedDigitExtractionServerEdit from './containers/TLSProfileEdit';
import TLSProfileView from './containers/TLSProfileView';
import { SYSTEM_CONFIGURATION_ROUTE, TLS_PROFILE, SECURITY } from '../../constants';

interface Props {
}

const TlsProfile: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${TLS_PROFILE}`}>
        <DialedDigitExtractionServerList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${TLS_PROFILE}/create`}>
        <DialedDigitExtractionServerCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${TLS_PROFILE}/edit`}>
        <DialedDigitExtractionServerEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${SECURITY}${TLS_PROFILE}/view`}>
        <TLSProfileView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default TlsProfile;
